import { render, staticRenderFns } from "./CourseModal.vue?vue&type=template&id=7a2b727a&"
import script from "./CourseModal.vue?vue&type=script&lang=js&"
export * from "./CourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a2b727a')) {
      api.createRecord('7a2b727a', component.options)
    } else {
      api.reload('7a2b727a', component.options)
    }
    module.hot.accept("./CourseModal.vue?vue&type=template&id=7a2b727a&", function () {
      api.rerender('7a2b727a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/professional-development/CourseModal.vue"
export default component.exports